
export class PanelConfigurationNonWorkingDay {
  id: number;
  nonWorkingDay: Date;
  description: string;
  dayOfWeek: string;
  applyExistingConfigurations: boolean;
}

export class PanelConfigurationNonWorkingDayModel {
  id: number;
  panelConfigurationNonWorkingDay: PanelConfigurationNonWorkingDay;
}
